import { useEffect, useState } from "react";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = (props: ToasterProps) => {
  const [position, setPosition] = useState<ToasterProps["position"]>("bottom-right");

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia("(max-width: 639px)");
    const apply = () => setPosition(mq.matches ? "top-center" : "bottom-right");
    apply();
    mq.addEventListener("change", apply);
    return () => mq.removeEventListener("change", apply);
  }, []);

  return (
    <Sonner
      theme="dark"
      position={position}
      offset={16}
      toastOptions={{
        unstyled: false,
        classNames: {
          toast:
            "group !bg-[#15151a] !text-white !border !border-white/10 !rounded-xl !shadow-[0_10px_40px_-10px_rgba(241,88,12,0.35),0_4px_16px_-6px_rgba(0,0,0,0.6)] relative !pl-5 before:content-[''] before:absolute before:left-0 before:top-2 before:bottom-2 before:w-[3px] before:rounded-full before:bg-gradient-to-b before:from-vl-orange before:to-vl-deep before:opacity-90",
          title: "!text-sm !font-semibold !text-white",
          description: "!text-xs !text-white/60",
          actionButton:
            "!bg-transparent !border !border-vl-orange/40 !text-vl-orange hover:!bg-vl-orange/10 !rounded-full !px-3 !py-1 !text-xs !font-semibold !transition-colors",
          cancelButton:
            "!bg-white/5 !text-white/70 hover:!bg-white/10 !rounded-full !px-3 !py-1 !text-xs !font-medium",
          closeButton: "!bg-white/5 !text-white/60 !border-white/10",
          icon: "!self-start !mt-0.5",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
